import React from 'react';
import { cleaningProducts } from '../data/mock';

const CleaningProducts = () => {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <img
              src={cleaningProducts.image}
              alt="Cleaning products"
              className="w-full rounded-2xl shadow-xl"
            />
          </div>
          <div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6 leading-tight">
              {cleaningProducts.title}
            </h2>
            <p className="text-lg text-gray-600 leading-relaxed">
              {cleaningProducts.description}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CleaningProducts;